import { render } from "./OneTimeCodeLogin.vue?vue&type=template&id=3ba5ee9c&scoped=true"
import script from "./OneTimeCodeLogin.vue?vue&type=script&lang=js"
export * from "./OneTimeCodeLogin.vue?vue&type=script&lang=js"

import "./OneTimeCodeLogin.vue?vue&type=style&index=0&id=3ba5ee9c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba5ee9c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QForm,QInput,QBtn,QBanner,QBtnGroup,QField});
